<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row class="mb-3">
          <v-col md="12">
            <v-checkbox
              v-model="markitoStatus"
              class="mt-0"
              :label="$t('markitoStatusActive')"
              value="active"
            />
          </v-col>
<!--          <v-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--          >-->
<!--            <v-text-field-->
<!--              v-model="rate"-->
<!--              :label="$t('currencyRate')"-->
<!--              :rules="[v => !!v || $t('is-required')]"-->
<!--              outlined-->
<!--              clearable-->
<!--              :disabled="!markitoStatus"-->
<!--              dense-->
<!--            />-->
<!--          </v-col>-->
          <v-col
            cols="12"
            md="9"
          >
            <v-chip
              v-clipboard:copy="hashkey"
              label
              dark
              color="green"
              link
              @click="copied"
            >
              {{ $t('apiKey') }} {{$t('abriron')}} : {{ hashkey }}
              <v-icon class="mx-2">
                mdi-content-copy
              </v-icon>
            </v-chip>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="markitoWebhook"
              :label="$t('markitoWebhook')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              :disabled="!markitoStatus"
              placeholder="https://..."
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="apiKey"
              :label="$t('apiKey') + ' ' + $t('markito')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              placeholder="AiOiJK..."
              clearable
              :disabled="!markitoStatus"
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="entrepot"
              :title="$t('entrepotToUse')"
              type="entrepot"
              :outlined="true"
              :disabled="!markitoStatus"
              :value="entrepot"
            />
          </v-col>
<!--          <v-col md="2">-->
<!--            <v-checkbox-->
<!--              v-model="markitoUseOtherEntrepot"-->
<!--              class="mt-0"-->
<!--              :label="$t('digikalaUseOtherEntrepot')"-->
<!--              value="yes"-->
<!--            />-->
<!--          </v-col>-->
<!--          <v-col md="2">-->
<!--            <v-checkbox-->
<!--              v-model="markitoUpdateStock"-->
<!--              class="mt-0"-->
<!--              :disabled="!markitoStatus"-->
<!--              :label="$t('updateStock')"-->
<!--              value="yes"-->
<!--            />-->
<!--          </v-col>-->
<!--          <v-col md="2">-->
<!--            <v-checkbox-->
<!--              v-model="markitoUpdatePrice"-->
<!--              class="mt-0"-->
<!--              :disabled="!markitoStatus"-->
<!--              :label="$t('updatePrice')"-->
<!--              value="yes"-->
<!--            />-->
<!--          </v-col>-->
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
//   import autocomplete from '../../components/general/patial/autocomplete'
  import General from '../../../../Mixins/general'
  export default {
    name: 'Customer',
    components: {
      // aicomplete,
      // autocomplete,
    },
    mixins: [General],
    data: () => ({
      valid: true,
      apiName: null,
      apiName2: null,
      apiKey: null,
      apiKey2: null,
      markitoReturnSell: 'changeStatus',
      updatePrice: null,
      updateStock: null,
      removeStatus: null,
      markitoUseOtherEntrepot: null,
      markitoReturnSellStatus: null,
      registerStatus: null,
      markitoUpdateStock: null,
      markitoUpdatePrice: null,
      markitoWebhook: null,
      entrepot: null,
      entrepotEdit: null,
      username: null,
      paymentItems: [],
      markitoStatus: 'active',
      hashkey: null,
      rate: 1,
      password: null,
      domain: null,
      type: null,
      render: false,
      isLoading: false,
    }),
    watch: {
    },
    activated () {
      this.show()
    },
    beforeMount () {
      this.statusItems = [
        {
          value: 'not_completed',
          text: this.$t('not_completed'),
        },
        {
          value: 'canceled',
          text: this.$t('canceled'),
        },
        {
          value: 'not_completed',
          text: this.$t('not_completed'),
        },
        {
          value: 'unfulfilled',
          text: this.$t('unfulfilled'),
        },
        {
          value: 'fulfilled',
          text: this.$t('fulfilled'),
        },
      ]
    },
    mounted () {
      this.show()
    },
    methods: {
      addPaymentMethod () {
        this.paymentItems.push({
          bank: null,
          value: null,
        })
      },
      remove (index) {
        this.paymentItems.splice(index, 1)
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'markito', this.$data)
          .then(res => {
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'markito', {
          params: {
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.entrepot = res.entrepot
              app.markitoUpdateStock = res.markitoUpdateStock
              app.markitoUpdatePrice = res.markitoUpdatePrice
              app.apiKey = res.markitoApiKey
              app.paymentItems = res.markitoPaymentItems
              app.markitoStatus = res.markitoStatus
              app.markitoWebhook = res.markitoWebhook
              app.rate = res.markitoCurrencyRate
              app.hashkey = res.hashkey
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      copied () {
        this.snakbarText = this.$t('copied')
        this.snakbarColor = 'blue'
        this.snakbar = true
      },
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
